// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"530":"8e3da9b6","1563":"44442122","7100":"99ee7dd7","7887":"6de7cd5b"}[chunkId] + ".chunk.css";
};